import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { OrgContext } from '../contexts/OrgContext';
import { CircularProgress, Box, Typography } from '@mui/material';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading: authLoading } = useContext(AuthContext);
  const { orgId, loading: orgLoading } = useContext(OrgContext);
  const location = useLocation();
  const currentPath = location.pathname;

  // Show loading state
  if (authLoading || orgLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Handle authentication
  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: currentPath }} replace />;
  }

  // Handle organization context
  if (!orgId && !currentPath.startsWith('/list-orgs')) {
    return <Navigate to="/list-orgs" replace />;
  }

  return children;
}

export default ProtectedRoute;
